// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"FormWrapper_formContainer__1xo7G"};